export const QUERY_PARAM_OKTA_ACCOUNT: string = 'okta-account';
export const QUERY_PARAM_TAG_ID: string = 'tag-id';
export const QUERY_PARAM_DEAL_TASK_ID: string = 'task-id';
export const QUERY_PARAM_DEAL_PARTICIPANT_ID: string = 'participant-id';
export const QUERY_PARAM_DEAL_FILE_ID: string = 'file-id';
export const QUERY_PARAM_TAB: string = 'tab';
export const QUERY_PARAM_CODE: string = 'code';
export const QUERY_PARAM_STATE: string = 'state';
export const QUERY_PARAM_COMMENT_ID: string = 'comment-id';
export const QUERY_PARAM_CATEGORY: string = 'category';
export const QUERY_PARAM_PAGE: string = 'page';
export const QUERY_PARAM_LIMIT: string = 'limit';
export const QUERY_PARAM_ACCOUNT_USER_TYPE: string = 'account-user-type';
export const QUERY_PARAM_ACTIVE: string = 'active';
export const QUERY_PARAM_ROLE: string = 'role';
export const QUERY_PARAM_DEAL_ID: string = 'deal-id';
export const QUERY_PARAM_BROKER_ID: string = 'broker-id';
export const QUERY_PARAM_LENDER_ID: string = 'lender-id';
export const QUERY_PARAM_INVESTOR_ID: string = 'investor-id';
export const QUERY_PARAM_DEAL_CONTACT_ID: string = 'deal-contact-id';
export const QUERY_PARAM_TYPE: string = 'type';
export const QUERY_PARAM_CONTACT_ID: string = 'contact-id';
export const QUERY_PARAM_STATUS: string = 'status';
export const QUERY_PARAM_ACCESS_LEVEL: string = 'access-level';
export const QUERY_PARAM_CONTACT_TYPE: string = 'contact-type';
export const QUERY_PARAM_LOCATION: string = 'location';
export const QUERY_PARAM_COMPANY_ID: string = 'company-id';
export const QUERY_PARAM_ASSET_TYPE: string = 'asset-type';
export const QUERY_PARAM_DEAL_TYPE: string = 'deal-type';
export const QUERY_PARAM_DEAL_SIZE: string = 'deal-size';
export const QUERY_PARAM_TEMPLATE: string = 'template';
export const QUERY_PARAM_QUERY: string = 'query';
export const QUERY_PARAM_EDIT_MODE: string = 'edit-mode';
export const QUERY_PARAM_CREATE: string = 'create';
export const QUERY_PARAM_EMAIL_CONNECTOR_CODE: string = 'email-connector-code';
export const QUERY_PARAM_PORTFOLIO_ID: string = 'portfolio-id';
export const QUERY_PARAM_PORTFOLIO_IDS: string = 'portfolio-ids';
export const QUERY_PARAM_PORTFOLIO_GROUP_IDS: string = 'portfolio-group-ids';
